import { useState, useCallback } from 'react'
import { cities } from './data/cities.js'
import { QUESTION_COUNT, RIGHT_REVEAL_DELAY, WRONG_REVEAL_DELAY } from './config.js'
import StartScreen from './components/StartScreen.jsx'
import GameScreen from './components/GameScreen.jsx'
import EndScreen from './components/EndScreen.jsx'

function shuffle(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

function buildQuestion(correct, allCities) {
  const otherCountries = allCities.filter(c => c.countrycode !== correct.countrycode)
  
  const seen = new Set()
  const uniqueWrongs = shuffle(otherCountries).filter(c => {
    const key = c.countrycode  // ← dédoublonne par pays, pas par ville
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })

  const wrongs = uniqueWrongs.slice(0, 3)

  const options = shuffle([
    { label: `${correct.city} (${correct.state})`, correct: true },
    ...wrongs.map(c => ({ label: `${c.city} (${c.state})`, correct: false }))
  ])

  return { image: correct.image, options, correct }
}

function generateGame(allCities) {
  const seen = new Set()
  const uniqueEntries = shuffle(allCities).filter(c => {
    const key = `${c.city}-${c.countrycode}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
  const questions = uniqueEntries.slice(0, QUESTION_COUNT).map(correct => buildQuestion(correct, allCities))
  // console.log(questions)  //
  return questions
}

export default function App() {
  const [phase, setPhase] = useState('start')
  const [questions, setQuestions] = useState([])
  const [currentQ, setCurrentQ] = useState(0)
  const [results, setResults] = useState([])

  const startGame = useCallback(() => {
    setQuestions(generateGame(cities))
    setCurrentQ(0)
    setResults([])
    setPhase('ingame')
  }, [])

const handleAnswer = useCallback((correct) => {
  const newResults = [...results, correct]
  setResults(newResults)

  const delay = correct ? RIGHT_REVEAL_DELAY : WRONG_REVEAL_DELAY

  if (currentQ + 1 >= questions.length) {
    setTimeout(() => setPhase('end'), delay)
  } else {
    setTimeout(() => setCurrentQ(q => q + 1), delay)
  }
}, [results, currentQ, questions.length])

  if (phase === 'start') return <StartScreen onStart={startGame} />
  if (phase === 'ingame') return (
    <GameScreen
      question={questions[currentQ]}
      questionIndex={currentQ}
      total={questions.length}
      results={results}
      onAnswer={handleAnswer}
    />
  )
  if (phase === 'end') return <EndScreen results={results} onRestart={startGame} />
}